import React from "react";
import { useHistory } from "react-router-dom";
import { loginAPI } from "../../Services/authService.js";
import GoogleSignIn from "./GoogleSignIn";
import useAuthStore from "../../Store/AuthStore.jsx";
import { fetchAndSendSavedProductsToApi } from "../../Utils/ProductUtil.jsx";
import { trackEvent } from "../../Utils/GoogleTag.jsx";
import { encodeSearchText } from "../../Utils/urlEncoder.js";
import { Form, SmartFormField, SubmitButton } from "../ui/Form";
import { loginSchema } from "../../schemas/authSchema";
import { useTranslation } from "react-i18next";

const SignIn = ({ setIsSignIn }) => {
  const { t } = useTranslation();
  const { login: setLogin } = useAuthStore();
  const history = useHistory();

  const handleLogin = async (data, { setFormError }) => {
    trackEvent("Button", "Click", "Sign in with Email");

    const response = await loginAPI(data.email, data.password);

    if (response.status === 403) {
      throw new Error("Invalid email or password. Please try again.");
    }

    const token = await response.json();
    window.localStorage.setItem("token", token.token);
    window.localStorage.setItem("email", data.email);
    localStorage.setItem("loggedin", JSON.stringify(true));
    await setLogin(data.email, token.token);
    fetchAndSendSavedProductsToApi();

    // Check if we have a stored search query from an unauthenticated user
    const unauthUserSearchText = localStorage.getItem("unauthUserSearchText");
    if (unauthUserSearchText) {
      const encodedSearchText = encodeSearchText(unauthUserSearchText);
      history.push(`/search?query=${encodedSearchText}`);
    } else {
      history.push("/search");
    }

    trackEvent("Button", "Clicked", "Sign in with Email");
  };

  return (
    <div className="w-full max-w-md space-y-8">
      <div>
        <h2 className="mt-6 text-center text-3xl font-bold text-neutral-green-800">
          {t("career.welcomeTo")} <span className="text-red-500">Ciqler</span>
        </h2>
        <p className="mt-2 text-center text-sm text-neutral-green-600">
          {t("career.signInOrCreate")}
        </p>
      </div>
      <div className="space-y-4">
        <GoogleSignIn />
      </div>
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-neutral-green-300" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className=" bg-grey-100 px-2 text-neutral-green-600">
            {t("career.orContinueWith")}
          </span>
        </div>
      </div>
      <div className="space-y-6">
        <Form
          schema={loginSchema}
          onSubmit={handleLogin}
          defaultValues={{ email: "", password: "" }}
          className="space-y-4"
        >
          <SmartFormField
            name="email"
            label={t("career.email")}
            type="email"
            required
            inputProps={{
              placeholder: "m@example.com", variant: "box",
            }}
          />

          <SmartFormField
            name="password"
            label={t("career.password")}
            type="password"
            required
            inputProps={{
              placeholder: t("career.password"), variant: "box",
            }}
          />

          <div className="flex flex-row-reverse items-center justify-between pt-2">
            <div className="text-sm">
              <a
                href="/forget-password"
                className="font-medium text-red-600 hover:underline"
              >
                {t("career.forgotPassword")}
              </a>
            </div>
          </div>

          <SubmitButton
            variant="primary"
            size="md"
            fullWidth
            className="mt-4"
          >
            {t("career.signIn")}
          </SubmitButton>
        </Form>
      </div>
      <div className="flex items-center justify-center">
        <div className="text-sm">
          {t("career.dontHaveAccount")}{" "}
          <a
            href="#"
            className="font-medium text-red-600 hover:underline"
            onClick={(e) => {
              e.preventDefault();
              setIsSignIn(false);
            }}
          >
            {t("career.signUp")}
          </a>
        </div>
      </div>
    </div>
  );
};

export default SignIn;